import { useState, type ReactNode } from 'react';

interface AcordeaoProps {
  titulo: string;
  /** Resumo mostrado ao lado do título quando fechado. */
  resumo?: ReactNode;
  abertoInicial?: boolean;
  children: ReactNode;
}

// Seção recolhível com animação de altura de 200 ms. No PDF abre sempre.
export default function Acordeao({
  titulo,
  resumo,
  abertoInicial = false,
  children,
}: AcordeaoProps) {
  const [aberto, setAberto] = useState(abertoInicial);

  return (
    <section className="rel-secao overflow-hidden rounded-2xl border border-background-200 bg-white shadow-[0_1px_3px_rgba(16,24,40,0.04)]">
      <button
        type="button"
        onClick={() => setAberto((a) => !a)}
        aria-expanded={aberto}
        className="flex w-full cursor-pointer items-center justify-between gap-3 px-4 py-3.5 text-left md:px-5"
      >
        <span className="flex min-w-0 flex-col">
          <span className="text-[15px] font-bold text-foreground-950">{titulo}</span>
          {resumo && <span className="mt-0.5 text-[13px] tabular-nums text-foreground-500">{resumo}</span>}
        </span>
        <span
          className={`rel-caret flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform duration-200 ${
            aberto ? 'rotate-180' : ''
          }`}
        >
          <i className="ri-arrow-down-s-line text-lg" />
        </span>
      </button>
      <div
        className={`rel-acordeao grid transition-[grid-template-rows] duration-200 ease-out motion-reduce:transition-none ${
          aberto ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
      >
        <div className="overflow-hidden">
          <div className="border-t border-background-100 px-4 py-4 md:px-5">{children}</div>
        </div>
      </div>
    </section>
  );
}